import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, g = ({ size: e = 16, useVw: t, useRem: l, color: o, withColor: c, removeClassName: n, disableSSR: m, style: i, ...h }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-zhangdanmingxi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "32px-è´¦åæç»"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.5 8.656a4.006 4.006 0 0 1 4.006-4.006h11.388A4.006 4.006 0 0 1 27.9 8.656v2.713a.9.9 0 1 1-1.8 0V8.656a2.206 2.206 0 0 0-2.206-2.206H12.506A2.206 2.206 0 0 0 10.3 8.656V24.25a1.3 1.3 0 0 0 1.196 1.296l.66.004H24.8a1.3 1.3 0 0 0 1.3-1.3v-5.934c0-.782-.634-1.416-1.416-1.416h-10.42a.9.9 0 0 1 0-1.8h10.42a3.216 3.216 0 0 1 3.216 3.216v5.934a3.1 3.1 0 0 1-3.1 3.1H11.6a3.14 3.14 0 0 1-.168-.004l-3.158-.02a4.2 4.2 0 0 1-4.174-4.2v-7.065a2.611 2.611 0 0 1 2.611-2.61h1.79V8.655ZM6.711 15.25h1.79v9c0 .456.098.89.274 1.28l-.49-.004a2.4 2.4 0 0 1-2.385-2.4v-7.065a.81.81 0 0 1 .811-.81Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.263 10.469a.9.9 0 0 0 0 1.8h6.369a.9.9 0 1 0 0-1.8h-6.369Z"
        }
      )
    )
  )));
}, s = g;
export {
  s as default
};
